import React from "react";
import { List } from "../modules/DataExports";

export function ExportsPage(props) {
  return <List {...props} />;
}
